import { CustomCellActionsComponent } from '@app/components/shared/grids/custom-cell-actions/custom-cell-actions.component';
import { TabNames } from '@enums/TabNames';
import { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-enterprise';

export const CONTACT_BUILDINGS_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'buildingId',
        field: 'buildingId',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/buildings-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'buildingName',
        field: 'buildingName',
        headerName: 'Name',
        cellDataType: 'text'
    },
    {
        colId: 'buildingContactRoleName',
        field: 'buildingContactRoleName',
        headerName: 'Contact Role',
        cellDataType: 'text'
    },
    {
        colId: 'buildingAddressLines',
        field: 'buildingAddressLines',
        headerName: 'Address',
        cellDataType: 'text',
        sortable: false,
        valueFormatter: (params: ValueFormatterParams) => {
            if (Array.isArray(params.value)) {
                return params.value.filter(Boolean).join(', ');
            }
            return params.value || '';
        }
    },
    {
        colId: 'buildingCityName',
        field: 'buildingCityName',
        headerName: 'City',
        cellDataType: 'text'
    },
    {
        colId: 'buildingStateName',
        field: 'buildingStateName',
        headerName: 'State',
        cellDataType: 'text'
    },
    {
        colId: 'buildingCountryName',
        field: 'buildingCountryName',
        headerName: 'Country',
        cellDataType: 'text'
    },
    {
        colId: 'actions',
        headerName: '',
        maxWidth: 80,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellActionsComponent,
        cellClass: 'action-cell'
    }
];
